import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Qué son los créditos y cómo funcionan?',
    answer: 'Cada solicitud de canje cuesta 1 crédito. Si la contraparte rechaza tu solicitud, el crédito se devuelve automáticamente. Si acepta, el crédito se consume. El plan gratuito incluye 3 créditos mensuales, el plan Pro incluye 20 créditos mensuales.'
  }, {
    question: '¿Puedo publicar propiedades gratis?',
    answer: 'Sí, publicar propiedades es completamente gratis para todos los usuarios. Los créditos solo se usan para solicitar canjes, no para publicar.'
  }, {
    question: '¿Qué pasa si me rechazan una solicitud de canje?',
    answer: 'Si tu solicitud es rechazada, el crédito se devuelve automáticamente a tu cuenta. Solo se consume el crédito cuando la contraparte acepta tu solicitud.'
  }, {
    question: '¿Canjee es una red privada?',
    answer: 'Sí, Canjee es una red privada y exclusiva. Solo puedes acceder y ver propiedades si tienes una cuenta activa en la plataforma.'
  }, {
    question: '¿Cuándo se lanza Canjee?',
    answer: 'Lanzamos oficialmente el 1 de enero de 2026. Si te unes a la lista de espera, recibirás beneficios exclusivos al lanzamiento.'
  }, {
    question: '¿Qué incluye el Plan Empresa?',
    answer: 'El Plan Empresa es personalizado según las necesidades de tu equipo o corredora. Incluye créditos a medida, gestión de equipos y soporte prioritario. Contáctanos para una cotización.'
  }, {
    question: '¿Cómo se reparte la comisión?',
    answer: 'Por defecto es 50/50, pero es completamente editable según lo que acuerden ambas partes en el acuerdo de canje.'
  }, {
    question: '¿Cómo se verifica un cierre?',
    answer: 'Mediante doble confirmación in-app (promesa/escritura) más un comprobante ligero como la carátula del documento.'
  }];
  return <section id="faq" className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <div className="text-center mb-12 sm:mb-16" data-id="element-99">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-100">
            Preguntas frecuentes
          </h2>
        </div>
        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-indigo-900 transition-all" data-id="element-102">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left" data-id="element-103">
                <span className="font-semibold text-sm sm:text-base text-gray-900 pr-4" data-id="element-104">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-600 flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-105" />
              </button>
              {openIndex === index && <div className="px-5 sm:px-6 pb-4 sm:pb-5" data-id="element-106">
                  <p className="text-sm sm:text-base text-gray-700" data-id="element-107">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}